import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            探索内容分类
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            多维度内容分类，助你快速找到心仪的精品佳作
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 md:p-6 rounded-lg bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-lg bg-secondary-100 group-hover:bg-primary-100 transition-colors duration-200 mb-3">
                <i className={`${cat.icon} text-xl md:text-2xl text-secondary-600 group-hover:text-primary-500 transition-colors duration-200`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400 mt-1 text-center">
                {cat.description.slice(0, 16)}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}